import { BehaviorSubject } from 'rxjs'
import { Horse, HorseApi } from '../api'
import { authState } from './Auth.state'
import { appState } from './App.state'

interface HorsesState {
  horses$: BehaviorSubject<Horse[]>
  fetchHorses: (ids: string[]) => Promise<Horse[]>
  fetchHorseById: (id: string) => Promise<Horse>
}

export const horsesState: HorsesState = {
  horses$: new BehaviorSubject<Horse[]>([]),
  fetchHorses: async (ids: string[]) => {
    if (!ids || ids.length === 0) return []
    return Promise.all(ids.map(horsesState.fetchHorseById))
  },
  fetchHorseById: async (registerId: string) => {
    if (!registerId || registerId?.length < 1) {
      appState.addToast('Keine RegId angegeben!', 'error')
      throw new Error(`no regid given`)
    }
    return new HorseApi(authState.apicfg()).apiHorseRegisterIdGet({ registerId })
  }
}
